module.exports = __webpack_public_path__ + "static/media/041-bike.fa6b2696.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/041-bike.svg
// module id = 201
// module chunks = 0